import { render, staticRenderFns } from "./AdminEditBranch.vue?vue&type=template&id=6aada1d9&scoped=true&"
import script from "./AdminEditBranch.vue?vue&type=script&lang=js&"
export * from "./AdminEditBranch.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditBranch.vue?vue&type=style&index=0&id=6aada1d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aada1d9",
  null
  
)

export default component.exports